// Error reporting as the app sees it. The Sentry SDK runs in its own bundle (/build/telemetry.js,
// loaded before the page's bundle); when it failed to load there is no window.PubgolfTelemetry
// and every call here does nothing. Uncaught errors are reported by the SDK itself; use reportError
// for errors the app catches.

export interface TelemetryApi {
  report(error: unknown, tags?: Record<string, string>): void;
  tag(name: string, value: string | null): void;
  note(message: string, level: 'info' | 'warning' | 'error'): void;
}

export const TELEMETRY_GLOBAL = 'PubgolfTelemetry';

function api(): TelemetryApi | undefined {
  return (window as unknown as Record<string, TelemetryApi | undefined>)[TELEMETRY_GLOBAL];
}

export function reportError(error: unknown, tags?: Record<string, string>): void {
  try {
    api()?.report(error, tags);
  } catch {
    // Reporting must never break the page.
  }
}

export function setErrorTag(name: string, value: string | null): void {
  try {
    api()?.tag(name, value);
  } catch {
    // ignore
  }
}

export function errorNote(message: string, level: 'info' | 'warning' | 'error' = 'info'): void {
  try {
    api()?.note(message, level);
  } catch {
    // ignore
  }
}
